import { PureComponent, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { assign, last } from 'lodash-es';

import Form from 'components/Form';

import { apiRegister, getPlanDetails } from 'constants/api';

import { PersonalData, BusinessData } from './components';

import { REGISTRATION_VALUES_PARTNER, REGISTRATION_TYPE } from './constants';

class Registration extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { isShown: false, isEmailValid: false };
  }

  setEmailStatus = bool => {
    this.setState({ isEmailValid: bool });
  };

  toggleForm = () =>
    this.setState(({ isShown }) => ({
      isShown: !isShown,
    }));

  handlePostMember = async values => {
    const { data } = await getPlanDetails();
    const { planId, periods } = data[REGISTRATION_TYPE];
    const { currency, periodId } = last(periods);
    const { currencyId } = currency;
    const result = {};

    assign(result, values, { planId, periodId, currencyId });

    return apiRegister.postMember(result, REGISTRATION_TYPE);
  };

  handleResponse = ({ data }) => {
    if (data.uid) {
      this.props.history.push('/checkout', {
        uid: data.uid,
        type: REGISTRATION_TYPE,
      });
    }
  };

  render() {
    const { isShown, isEmailValid } = this.state;
    return (
      <Fragment>
        <section className="section section_register">
          <div className="wrapper">
            <Form
              autoComplete="off"
              initialValues={REGISTRATION_VALUES_PARTNER}
              request={this.handlePostMember}
              onResponse={this.handleResponse}
            >
              {formProps => (
                <TransitionGroup className="section__content-wrap">
                  <CSSTransition
                    classNames={!isShown ? 'fade_left' : 'fade_right'}
                    timeout={300}
                    key={isShown}
                  >
                    <div>
                      {!isShown ? (
                        <PersonalData
                          {...formProps}
                          type={REGISTRATION_TYPE}
                          toggle={this.toggleForm}
                          onValid={this.setEmailStatus}
                          isValid={isEmailValid}
                        />
                      ) : (
                        <BusinessData
                          {...formProps}
                          type={REGISTRATION_TYPE}
                          toggle={this.toggleForm}
                        />
                      )}
                    </div>
                  </CSSTransition>
                </TransitionGroup>
              )}
            </Form>
          </div>
        </section>
      </Fragment>
    );
  }
}

export default withRouter(Registration);
